import { useEffect } from "react";
import Barcode from "react-barcode";
import { useParams } from "react-router-dom";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import "./barcode.scss";

const PrintBarcode = () => {
    const { id, qty } = useParams();
    const basicBarCode = "00000000";
    const { data: product, refetch: refetchProduct } = useGetPageQuery("products/" + id);

    useEffect(() => {
        document.body.classList.add("barcode-mode");
        return () => {
            document.body.classList.remove("barcode-mode");
        };
    }, []);

    return (
        <>
            {product && (
                <>
                    {Array(+qty)
                        .fill(true)
                        .map((_, i) => {
                            return (
                                <div
                                    className="content-barcode-container"
                                    key={i}
                                >
                                    <div
                                        className="content-barcode-text"
                                        style={{ marginBottom: "-4px" }}
                                    >
                                        ID {product.id} {product.barcode ? product.barcode : product.title} (
                                        {product?.imei_sn.slice(-5)})
                                    </div>
                                    <div className="content-barcode__code">
                                        <Barcode
                                            value={basicBarCode.slice(id.length) + id}
                                            displayValue={false}
                                            width={3 / 2}
                                            height={30}
                                            marginBottom={0}
                                            marginTop={0}
                                            className={"barcode"}
                                        />
                                        <div className="content-barcode__code-text">{product?.store?.title}</div>
                                    </div>

                                    <div
                                        className="content-barcode__bottom-price"
                                        style={{ marginTop: "-6px" }}
                                    >
                                        {product?.price_usd}$
                                    </div>
                                    {/* <div className="content-barcode-text">{product?.price_usd}$</div> */}
                                </div>
                            );
                        })}
                </>
            )}
        </>
    );
};

export default PrintBarcode;
